/**
 * The origin a booth should be SHARED at, from the visitor's point of view.
 *
 * Every shareable artifact /new produces (QR code, copy-link, booth rail
 * hrefs, the printed strip footer) used to hardcode https://dreambooth.app.
 * That is right on dreambooth.app itself and wrong everywhere else — a
 * creator building on app.dreamboothstudio.com/new?mode=digital was handed
 * links that jumped domains, and the rule is: whatever host you are on, you
 * stay on it.
 *
 * On a digital-mode web host the answer is the host itself; in the kiosk
 * shell (Electron/Tauri have no shareable web origin of their own) it stays
 * the canonical consumer domain.
 */
import { getAppMode } from '../../lib/runtime/mode'

const CANONICAL = 'https://dreambooth.app'

export function publicBoothOrigin(): string {
  if (typeof window === 'undefined') return CANONICAL
  try {
    if (getAppMode() === 'digital' && window.location.protocol.startsWith('http')) {
      return window.location.origin
    }
  } catch {
    /* mode resolution should never break link building */
  }
  return CANONICAL
}

/** Host label for display next to a slug, e.g. "dreambooth.app/". */
export function publicBoothHostLabel(): string {
  return publicBoothOrigin().replace(/^https?:\/\//, '')
}

/** Absolute URL for a booth slug on the correct origin. */
export function publicBoothUrl(slug: string): string {
  return `${publicBoothOrigin()}/${slug}`
}
